import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemEventsEditRoute: InvariantJiraRoute = {
	name: 'global-settings-system-events-edit',
	path: '/secure/admin/EditEventType.jspa',
};
